import React from "react";
var TrackArtistError;
(function (TrackArtistError) {
    TrackArtistError["Empty"] = "empty";
})(TrackArtistError || (TrackArtistError = {}));
var mapErrorToMessage = function (key) {
    var _a;
    if (!key)
        return "";
    return (_a = {}, _a[TrackArtistError.Empty] = "Введите исполнителя", _a)[key];
};
export var useTrackArtistEdit = function (initial) {
    var _a = React.useState(initial), artist = _a[0], setArtist = _a[1];
    var _b = React.useState(null), error = _b[0], setError = _b[1];
    var validate = function () {
        var key = null;
        if (artist.length === 0) {
            key = TrackArtistError.Empty;
        }
        setError(key);
        return key === null;
    };
    return {
        value: artist,
        set: setArtist,
        error: {
            value: Boolean(error),
            set: setError,
            key: error,
            message: mapErrorToMessage(error),
        },
        validate: validate,
    };
};
